import React from 'react';

interface ProfilineConfigurationProps {
    configuration: {
        Url?: string;
        Warehouses?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface ProfilineConfigurationComponent extends React.FC<ProfilineConfigurationProps> {
    configFields: string[];
}

const ProfilineConfiguration: ProfilineConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.Url || ''}
                        onChange={(e) => onChange('Url', e.target.value)}
                        placeholder="https://api.profiline.example.com"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
ProfilineConfiguration.configFields = ['Url'];

export default ProfilineConfiguration;
